<template>
  <div class="past-metup-div">  
        <div class="date-title-div"><samp class="icon-date-meetup">&#60;</samp> &nbsp; {{this.year}} &nbsp; <samp class="icon-date-meetup">&#62;</samp></div>
        <div class="black-separation"></div>
        <div class="sl-div-scroll">
          <div class="meetup-detail-container">
            <meetup-details :meetups="serviceLinesYear" :isupcoming="isNotUpComing" />
          </div>
        </div>
      </div>
</template>
<script>
  import Vue from 'vue';
  import MeetupDetails from '@/components/ServiceLines/MeetupDetails';
  import { mapActions } from "vuex";
  export default {
    name: 'meetup-per-year',
    components: {
      MeetupDetails
    }, 
    props: { 
        search:String,
        type:String
    },
    updated() {
      console.log("updated")
    },
    data() {
      this.loadServiceLines();
      return {
          lang: Vue.i18n.locale(),
          serviceLinesYear: [],
          year:new Date().getFullYear(),
          isNotUpComing:false
      };
    },
     methods:{
      ...mapActions(["GetListServiceLines"]),
      async loadServiceLines() {
        this.getYear();
      },
      async getYear(){
        let sLRequest= {
            search: this.search,
            lang: Vue.i18n.locale(),
            type:this.type,
            filter:this.year
          };
        console.log(this.search);
        await this.GetListServiceLines(sLRequest);
        this.serviceLinesYear = this.$store.getters.AllServiceLines; 
      },
      async searchServiceLines(){
        this.getYear();
      },
      async getSlPreviousYear(){
        this.year=this.year-1;
        this.getYear();
      },
      async getSlNextYear(){
        if(this.year<new Date().getFullYear()){
          this.year=this.year+1;
          this.getYear();
        }
      }


    }
  };
</script>
